import { withStyles } from '@material-ui/core';
import { Typography } from '@material-ui/core';
import Categories from 'connect/core/controls/categories';
import cache from 'connect/web/src/cache';
import type HistoryStore from 'connect/web/src/stores/history-store';
import type SearchStore from 'connect/web/src/stores/search-store';
import { action } from 'mobx';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import type { OnlineServiceCategory } from 'tm3-core/api.dtos';
import styles from './styles';

interface IProps {
  classes: {
    grid: string;
  };
  title: string;
  description: string;
  footer: string;
  categoryIds: string;
  searchStore: SearchStore;
  historyStore: HistoryStore;
}

@inject('searchStore', 'historyStore')
@observer
class Explore extends React.Component<IProps> {
  render() {
    const {
      title,
      description,
      footer,
      categoryIds = '[]',
      classes: { container },
      searchStore: { categories }
    } = this.props;

    const list = JSON.parse(categoryIds)
      .map((id) => categories.find((c) => c.id === id))
      .filter(BzNotFalsy);

    return (
      <div className={`container ${container}`}>
        {title && (
          <Typography color="primary" component="h1">
            {title}
          </Typography>
        )}
        {description && <Typography>{description}</Typography>}
        <Categories categories={list} onClick={this.onClick} />
        {footer && <Typography>{footer}</Typography>}
      </div>
    );
  }
  @action.bound
  onClick(category: OnlineServiceCategory) {
    let slug = category.urlSlug;
    if (!!category.rootSlug) {
      slug = category.rootSlug;
    }

    this.props.historyStore!.push('/book/' + encodeURI(slug));
  }
}

export default withStyles(styles, { withTheme: true })(Explore);
